import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { RoleSysConsentLog } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { NotFoundPage } from '../../../../page/not-found'
import { ConsentLogPage } from './consent-log-page'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'
import { SECTION } from '../../../../shared/navigation/sections'

// /admin/consent-log: the website's consent log for staff. The route itself
// is gated by SYS_CONSENT_LOG read, so a typed address without it says so; an
// address under it that is no page is the app's not-found page.
export const LayoutConsentLog = () =>
  <Route path="/admin/consent-log">
    <RoleSysConsentLog accessRead fallback={<NoAccess what="the consent log" />}>
      <Switch>
        <Route exact path="/admin/consent-log"><PageTrail trail={[SECTION.consentLog]} /><ConsentLogPage /></Route>
        <Route render={({ location }) => <NotFoundPage pathname={location.pathname} />} />
      </Switch>
    </RoleSysConsentLog>
  </Route>
